import { useEffect, useState } from 'react'
import { RudderAnalytics } from '@rudderstack/analytics-js'
import { initRudder, isRudderReady, onRudderReady } from './analytics/rudderClient'

/**
 * Hook to access the singleton RudderStack analytics instance
 * 
 * @returns [analytics, isReady] - analytics instance and ready state
 */
const useRudderStackAnalytics = (): [RudderAnalytics | undefined, boolean] => {
  const [isAnalyticsReady, setAnalyticsReady] = useState(false)
  const [analytics, setAnalytics] = useState<RudderAnalytics | undefined>(undefined)

  useEffect(() => {
    // Initialize singleton (idempotent - only runs once)
    const { analytics: instance } = initRudder()
    
    if (instance) {
      setAnalytics(instance)
      
      // Check if already ready
      if (isRudderReady()) {
        setAnalyticsReady(true)
      } else {
        // Subscribe to ready state
        onRudderReady(() => {
          setAnalyticsReady(true)
        })
      }
    }
  }, [])

  return [analytics, isAnalyticsReady]
}

export default useRudderStackAnalytics